import React, { useEffect, useState } from 'react';
import ToastComponent from './ToastComponent';
import toastService from './ToastService';
import { ToastSeverity } from './Enum';

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState("");
  const [isOpen,setIsOpen] = useState(false)

  useEffect(() => {
    const eventListener = (event) => {
      setToast(event.detail.message);
      setIsOpen(event.detail.isOpen)
      setTimeout(()=> {
        setIsOpen(false);
      }, 3000)
    };

    window.addEventListener('openToast', eventListener);

    return () => {
      window.removeEventListener('openToast', eventListener);
    };
  }, []);

  return (
    <div>
      {children}
      {isOpen && <ToastComponent isOpen={isOpen} message={toast} serverity={ToastSeverity.Error}/>}
    </div>
  );
};

export default ToastProvider;
